/**
 * TV Advertising service page
 * Converted blue accent theme to orange
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Tv, CheckCircle } from 'lucide-react'

export default function TVAdvertisingPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-orange-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">TV Advertising</h1>
              <p className="text-xl text-orange-100 leading-relaxed mb-8">
                Strategic television campaign planning and buying across national and regional networks 
                to maximize your brand's reach and impact with targeted audience engagement.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Launch TV Campaign</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/cd245a50-219a-4378-8375-b2a1f4d19e79.jpg" 
                alt="TV Advertising"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our TV Advertising Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Media Planning & Strategy</h3>
                    <p className="text-gray-600">Optimal time slots and channel selection for your target audience</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Creative Production</h3>
                    <p className="text-gray-600">High-quality TV commercial production and post-production</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Media Buying</h3>
                    <p className="text-gray-600">Negotiating best rates and premium placements</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Performance Tracking</h3>
                    <p className="text-gray-600">Detailed analytics and campaign optimization</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/0a638c34-7e85-4f38-ac21-d262bd1ff4bd.png" 
                alt="Television Production"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-orange-900 to-orange-700 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready for Prime Time?</h2>
          <p className="text-xl text-orange-100 mb-8">
            Let us create and place your TV campaigns for maximum impact and ROI
          </p>
          <Button asChild size="lg" className="bg-white text-orange-700 hover:bg-orange-50 text-lg px-8">
            <Link to="/contact">Start TV Campaign</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
